export var kijs = 'LULI';//'LULI';
export const resolutions =  [
	156543.03392800014,
	78271.516963999937,
	39135.758482000092,
	19567.879240999919,
	9783.9396204999593,
	4891.9698102499797,
	2445.9849051249898,
	1222.9924525624949,
	611.49622628137968,
	305.74811314055756,
	152.87405657041106,
	76.437028285073239,
	38.21851414253662,
	19.10925707126831,
	9.5546285356341549,
	4.7773142679493699,
	2.3886571339746849,
	1.1943285668550503,
	0.59716428355981721,
	0.29858214164761665
];
export const gdhServiceHost = '//api.geodatahub.eu';
export const apiServiceHost = '//api.kartes.lv';
export const wmsServiceHost = '//wms{1-4}.kartes.lv';
export const wmsServiceHostSingle =  'https://wms.kartes.lv';
export const vectorTilesBaseURL = '//maps.kartes.lv/kijs/vectortiles';
export const defaultLang = 'lv';
export const default_coords = [2684295, 7750224];
export const default_zoom = 8;
export const url_rewrite = {
	'/sastregumi': '/lv/c___2675421.85-7746319.66-12/sastregumi___/bl___melnbalta_karte',
	'/Sastregumi': '/lv/c___2675421.85-7746319.66-12/sastregumi___/bl___melnbalta_karte',
	'/traffic': '/en/c___2675421.85-7746319.66-12/sastregumi___/bl___melnbalta_karte',
	'/fotoradaru-karte': '/lv/c___2684295.00-7750224.00-11/fotoradari___/bl___cl',
	'/fotoradari': '/lv/c___2684295.00-7750224.00-11/fotoradari___/bl___cl'
}

export const colors = {
	gray: '#515151',
}